// Customised tweaked copy of the original form-submission-handler.js
// To accomodate Townsville's Mailchimp Newsletter Subscription Form
export default function initNewsletterFormSubmissionHandler(handlerOptions) {
    'use strict';

    const formOptions = {
        "formElement": null,
        "loadingMessageMarkup": '<p class="loading-message"><em>Loading form...</em></p>',
        "onLoadCallback": {},
        "scrollOnLoad": false,
        "validationFunction": function(){return true;}
    };

    let submitButtons = {};

    // Update the default form options
    for (let prop in handlerOptions) {
        formOptions[prop] = handlerOptions[prop];
    }

    // Check that at least a form has been provided
    if (formOptions.formElement === null || formOptions.formElement === undefined) {
        // console.log('Error: Unable to initialise initNewsletterFormSubmissionHandler(). No form provided.', formOptions);
        return;
    }

    // Insert the loading animation/message into the page
    formOptions.formElement.insertAdjacentHTML('beforeend', creatingLoadingMarkup(formOptions.loadingMessageMarkup));

    // Add a listener to each of the form's submit buttons so that we can track which button is submitting the form
    submitButtons = formOptions.formElement.querySelectorAll('[type=submit]');

    for (var i = 0, j = submitButtons.length; i < j; ++i) {
        submitButtons[i].addEventListener('click', function(evt){
            //hijackFormSubmission(evt, formOptions);
        });
    }
    
    /**
     * Respond to attempts to submit the form
     *
     * @param {MouseEvent} evt The event that triggered the submission
     * @param {Object} handlerOptions The handler options for the form (as set in initNewsletterFormSubmissionHandler())
     *
     * @returns void
     */
    function hijackFormSubmission(evt, handlerOptions) {
        const XHR = new XMLHttpRequest();
        let form = handlerOptions.formElement; // Capture all the form data
        let formData = new FormData(form); // Convert the form fields into FormData
        let formField = {};
        let submitBtn = {};

        evt.preventDefault();

        // Show the loading message
        form.getElementsByClassName('js-loading-message')[0].classList.add('is-active');

        // Check if the form passes validation (and/or other pre-submit actions)
        if (isFunction(handlerOptions.validationFunction) && !handlerOptions.validationFunction(form)) {
            // Hide the loading message
            form.getElementsByClassName('js-loading-message')[0].classList.remove('is-active');
            return;
        }
        
        submitBtn = formOptions.formElement.querySelector('[type=submit]');

        // Disable the submit button
        submitBtn.setAttribute("disabled", "");

        // Respond to requests to POST the form
        XHR.addEventListener('load', function(evt) {
            onFormRequestSuccess(evt, handlerOptions, submitBtn);
        });

        // Respond to request errors
        XHR.addEventListener('error', function(evt) {
            onFormRequestError(evt, handlerOptions, submitBtn);
        });

        // Callback function
        if (isFunction(handlerOptions.onLoadCallback)) {

            XHR.addEventListener('loadend', function(evt) {
                handlerOptions.onLoadCallback(evt, handlerOptions);
            });
        }

        // Set up our request
        XHR.open(form.getAttribute('method'), form.getAttribute('action'));

        // Make the request
        XHR.send(formData);
    }

    /**
     * Respond to the form submission LOAD event
     *
     * @param {ProgressEvent} evt The event as part of the XHR request
     * @param {Object} handlerOptions The handler options for the form (as set in initFormSubmissionHandler())
     *
     * @returns void
     */
    function onFormRequestSuccess(evt, handlerOptions, submitButton) {
        
        // Convert response string into DOM
        let responseDOM = new DOMParser().parseFromString(evt.currentTarget.response, "text/html")

        // Get all error elements MailChimp response might contain (if existing or blacklisted email was used to subscribe)
        let responseErrorElements = responseDOM.querySelectorAll(".errorText")

        // Find the ancestor wrapper which is holding the form
        let modalWrapper = handlerOptions.formElement.closest(".content-modal__body");

        let errorTextWrapper = modalWrapper.querySelector("#newsletter-form-submission-errors");

        if (!responseErrorElements.length) {

            // Remove the form element
            handlerOptions.formElement.remove();

            if (errorTextWrapper) {
                errorTextWrapper.remove();
            }

            // Show successful newsletter subscription message
            modalWrapper.querySelector("#newsletter-form-submission-success-msg").classList.remove("hidden");

        } else {

            if (!errorTextWrapper) {

                // Create new wrapper to hold error messages
                errorTextWrapper = document.createElement('div');

                errorTextWrapper.setAttribute('id', 'newsletter-form-submission-errors');
               
                modalWrapper.insertBefore(errorTextWrapper, handlerOptions.formElement);

            }

            // Clear out existing errors (if any)
            errorTextWrapper.innerHTML = "";

            responseErrorElements.forEach((errorText) => {

                errorTextWrapper.appendChild(errorText);

            });

            // Re-enable submit button
            submitButton.removeAttribute("disabled");

        }

        // Hide the loading message
        handlerOptions.formElement.getElementsByClassName('js-loading-message')[0].classList.remove('is-active');

        // Scroll to top of body container in modal
        modalWrapper.scrollTo({
            top: 0,
            left: 0,
            behavior: 'smooth'
        });

    }

    /**
     * Respond to the form submission ERROR event
     *
     * @param {ProgressEvent} evt The event as part of the XHR request
     * @param {Object} handlerOptions The handler options for the form (as set in initFormSubmissionHandler())
     * @param {HTMLElement} submitButton The button that initiated the form submission. Optional.
     *
     * @returns void
     */
    function onFormRequestError(evt, handlerOptions, submitButton) {
        
        let modalWrapper = handlerOptions.formElement.closest(".content-modal__body");

        let errorTextWrapper = modalWrapper.querySelector("#newsletter-form-submission-errors");

        if (!errorTextWrapper) {

            // Create new wrapper to hold error messages
            errorTextWrapper = document.createElement('div');

            errorTextWrapper.setAttribute('id', 'newsletter-form-submission-errors');
           
            modalWrapper.insertBefore(errorTextWrapper, handlerOptions.formElement);

        }

        errorTextWrapper.innerHTML = "Failed to submit the form. Please try again in a few minutes";

        submitButton.removeAttribute("disabled");
        
        // Hide the loading message
        handlerOptions.formElement.getElementsByClassName('js-loading-message')[0].classList.remove('is-active');

        // Scroll to top of body container in modal
        modalWrapper.scrollTo({
            top: 0,
            left: 0,
            behavior: 'smooth'
        });

    }

    /**
     * Create a new loading message
     *
     * @returns HTML as a String
     */
    function creatingLoadingMarkup(loadingMessage) {
        return '<div class="js-loading-message loading-container"><div class="sk-chase"><div class="sk-chase-dot"></div><div class="sk-chase-dot"></div><div class="sk-chase-dot"></div><div class="sk-chase-dot"></div><div class="sk-chase-dot"></div><div class="sk-chase-dot"></div></div>' + loadingMessage + '</div>';
    }

    /**
     * Check if an Object is a function
     *
     * @param {Object} functionToCheck The Object to check
     *
     * @returns Boolean
     */
    function isFunction(functionToCheck) {
        return functionToCheck && {}.toString.call(functionToCheck) === '[object Function]';
    }

}